<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_registrationCancellation"
      :custom="{ storage: true }"
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="code"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="seq" title="序号" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model.trim="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人手机号"
          min-width="140"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model.trim="listQuery.driverPhone"
            placeholder="请输入实际承运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="driverCode"
          title="实际承运人编号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model.trim="listQuery.driverCode"
            placeholder="请输入实际承运人编号"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="操作类型"
          :formatter="formatterType"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.type" clearable placeholder="请选择">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="operateTime"
          title="操作时间"
          min-width="280"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.operateTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'operateTime')"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { getDriverRegisterLogList } from "@/api/driver";

export default {
  name: "RegistrationCancellation",
  data() {
    return {
      loading: false,
      tableData: [],
      listQuery: {
        driverName: "",
        driverPhone: "",
        driverCode: "",
        type: "",
        operateTimeRange: [],
        operateTimeStart: "",
        operateTimeEnd: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      typeOptions: [{ value: 1, label: "注册" }, { value: 2, label: "注销" }]
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      const params = { ...this.listQuery };
      delete params.total;
      delete params.operateTimeRange;
      return getDriverRegisterLogList(params)
        .then(response => {
          this.tableData = response.data.records || [];
          this.listQuery.total = response.data.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatterType({ cellValue }) {
      switch (cellValue) {
        case 1:
          return "注册";
        case 2:
          return "注销";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
